<template>
  <v-row align="center" justify="start" no-gutters dense class="mb-2">
    <v-checkbox
      style="margin-top: 0;"
      hide-details
      dense
      color="warning"
      v-model="showExpirationModel"
      label="Afficher les avertissements"
    ></v-checkbox>
    <v-checkbox
      :class="{ 'ml-2': $vuetify.breakpoint.smAndUp }"
      style="margin-top: 0;"
      hide-details
      dense
      color="error"
      v-model="showWasteModel"
      label="Afficher les pertes"
    ></v-checkbox>
  </v-row>
</template>

<script>
export default {
  name: "InventoryExpirationAndWasteFilter",
  props: {
    showExpiration: {
      required: true
    },
    showWaste: {
      required: true
    }
  },
  computed: {
    showExpirationModel: {
      get() {
        return this.showExpiration;
      },
      set(v) {
        this.$emit("update:showExpiration", v);
      }
    },
    showWasteModel: {
      get() {
        return this.showWaste;
      },
      set(v) {
        this.$emit("update:showWaste", v);
      }
    }
  }
};
</script>

<style></style>
